// Add your custom JS here.
	
	window.addEventListener('DOMContentLoaded', function () {
        jQuery(window).on('scroll', function () {
          if (jQuery('.fv').height() < jQuery(this).scrollTop()) {
            jQuery('.js-header').addClass('change-color');
          } else {
            jQuery('.js-header').removeClass('change-color');
          }
        });
      });


      jQuery(function ($) {

      $('.slider').slick({
        autoplay: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        centerMode: true,
        variableWidth: true,
        dots: false
      });

      $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav'
      });

      $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        prevArrow: '<div class="slick-prev"></div>',
        nextArrow: '<div class="slick-next"></div>',
        dots: false,
        centerMode: true,
        focusOnSelect: true,
        responsive: [

            {
              breakpoint: 576,
              settings: {
                slidesToShow: 3,
              }
            }
          ]
      });
    });

      
  
